// APIは attributes(承認済み) と candidate_attributes(未承認) を文字列配列で返すため、
// 画面側で扱う { value, approved } の形に揃えて承認済みを先頭に並べる。
export function sortAttribute(result) {
  const approved = (result.attributes ?? []).map((a) => ({
    value: a,
    approved: true,
  }));
  const unapproved = (result.candidate_attributes ?? []).map((a) => ({
    value: a,
    approved: false,
  }));

  const sortedAtrributes = [...approved, ...unapproved].sort((a, b) => {
    if (a.approved && !b.approved) {
      return -1;
    }
    return 1;
  });

  return { ...result, attributes: sortedAtrributes };
}
